import './brands-listing.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initBrandsListing = (context) => {
  const brandsListingSection = context.closest('.shopify-section');
  if (!brandsListingSection) return;

  const letters = brandsListingSection.querySelectorAll('.brands-listing__navigation-letter');
  const brandsLetterContainer = brandsListingSection.querySelectorAll('.brands-listing__block');



  if (letters && brandsLetterContainer) {

    letters.forEach((letter, index) => {
      const letterSelector = letter.getAttribute('href');

      letter.addEventListener('click', (e)=> {
        e.preventDefault();
        letters.forEach(item => {
          if (item.classList.contains('active')) {
            item.classList.remove('active');
          }
          letter.classList.add('active');
        });
        if (letterSelector == '#letterAnchor-all') {
          brandsLetterContainer.forEach(brand => {
            brand.style.display = 'flex';
          });
        } else {
          brandsLetterContainer.forEach(brand => {
            brand.style.display = 'none';
          });
          brandsListingSection.querySelector(letterSelector).style.display = 'flex';
        }
      });
    });
  }

}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.brands-listing__container'), (el) => {
    window.dAgency.initBrandsListing(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.brands-listing__container'), (el) => {
      window.dAgency.initBrandsListing(el);
    });
  });
}
